import {
  CustomBlockingRulesOptions,
  type PublisherInventoryRule,
  type PublisherInventoryRuleOptions,
} from '@openx/types/targeting/inventoryAndContent.ts';
import type { ComparisonMap } from '@openx/types/targeting/targetingValuesTypes.ts';
import { sumLengths } from '@openx/utils/lib/sumLengths.ts';

export const getItemsCount = (value: string[] | ComparisonMap): number => {
  if (Array.isArray(value)) {
    return value.length;
  }
  return sumLengths(Object.values(value || {}), val => (val ? val.length : 0));
};

export const getPublisherInventoryRulesItemsCount = (
  rules: PublisherInventoryRule[],
  publisherInventoryRuleOptions: PublisherInventoryRuleOptions
): number => {
  const publisherRules = rules.filter(
    rule =>
      rule.publisher_id === publisherInventoryRuleOptions.publisherID &&
      rule.blockingRuleOption === publisherInventoryRuleOptions.blockingRuleOption
  );

  if (!publisherRules.length) return 0;

  const itemsLength =
    publisherRules[0].blockingRuleOption === CustomBlockingRulesOptions.BUNDLE_ID
      ? publisherRules[0].bundle_id.length
      : publisherRules[0].domain.length + publisherRules[0].subdomain.length;

  return itemsLength;
};
